<template>
	<div>
		<!-- begin breadcrumb -->
		<ol class="breadcrumb float-xl-right">
			<li class="breadcrumb-item active"><a href="javascript:;">Home</a></li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Home <small>header small text goes here...</small></h1>
		<!-- end page-header -->
		<panel title="Panel title here">
			<vue-good-table
				v-columns-resizable
				:columns="columns"
				:rows="rows"
				:line-numbers="true"
				:pagination-options="{
					enabled: true,
					mode: 'records',
					perPage: 5,
					nextLabel: '下一页',
					prevLabel: '上一页',
					rowsPerPageLabel: '每页行数',
					ofLabel: '行，共',
					pageLabel: 'page', // for 'pages' mode
					allLabel: '全部',
				}">
				>
			</vue-good-table>
		</panel>
	</div>
</template>

<script>
export default {
  data () {
    return {
			columns: [
				{label: '序号', field: 'id'},
				{label: '朝代', field: 'dynasty'},
			],
			rows: []
		}
	},
	async mounted() {
		let res=await this.callBasicApi()
		console.log(res)
		this.rows=res
	},
  methods: {
    callBasicApi() {
      return new Promise((resolve, reject) => {
        let ENDPOINT = "Names"
        this.axios
          .get(ENDPOINT)
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
	}
}
</script>
